export const SERVER_TYPE = {
  ENTERPRISE: 'ENTERPRISE',
  CUBE: 'CUBE',
};
